import * as type from '../../types/trans';
import {
    FOLIO_LIST_KARVY, GET_REGISTERED_BANKS, ORDER_GENERATION, PAYMENT_REQUEST, GET_PG_RESPONSE,
    VALIDATE_BROKER_CODE, PAYMENT_CHECK_MODE, PAYMENT_CHECK_NAME
} from "../../types/quickbuy";

export const saveSchemeCode = (data) => {
    console.log("saveSchemeCode action", data);
    return {
        type: type.CAT_SAVE_SCHEMECODE,
        payload: data
    }
}

export function saveCartData(data) {
    console.log("saveCartData action", data);
    return {
        type: type.SAVE_CART_BOX,
        payload: data
    }
}

export function removeCartData(data) {
    console.log("deletecart action", data);
    return {
        type: type.DEL_CART_BOX,
        payload: data
    }
}

export function replaceCartData(data) {
    console.log("replaceCartData action", data);
    return {
        type: type.REPLACE_CART_BOX,
        payload: data
    }
}

export function resetCartData() {
    return {
        type: type.RESET_CART_BOX
    }
}

//start cart order review 

export function saveCartOrderReviewData(data) {
    console.log("saveCartOrderReviewData action", data);
    return {
        type: type.SAVE_CART_ORDER_REVIEW_DATA,
        payload: data
    }
}

export function removeCartOrderReviewData(data) {
    console.log("removeCartOrderReviewData action", data);
    return {
        type: type.DEL_CART_ORDER_REVIEW_DATA,
        payload: data
    }
}

export function replaceCartOrderReviewData(data) {
    console.log("replaceCartOrderReviewData action", data);
    return {
        type: type.REPLACE_CART_ORDER_REVIEW_DATA,
        payload: data
    }
}

export function resetCartOrderReviewData() {
    return {
        type: type.RESET_CART_ORDER_REVIEW_DATA
    }
}
//end cart order review

export const folioList = (payload) => ({
    type: FOLIO_LIST_KARVY,
    payload
})

export const registerBank = (payload) => ({
    type: GET_REGISTERED_BANKS,
    payload
})

export const orderGenaration = (payload) => ({
    type: ORDER_GENERATION,
    payload
})

export const paymentRequest = (payload) => ({
    type: PAYMENT_REQUEST,
    payload
})

export const paymentResponse = (payload) => ({
    type: GET_PG_RESPONSE,
    payload
})

export const validateBroker = (payload) => ({
    type: VALIDATE_BROKER_CODE,
    payload
})

export const paymentCheckMode = (payload) => ({
    type: PAYMENT_CHECK_MODE,
    payload
})

export const paymentCheckName = (payload) => ({
    type: PAYMENT_CHECK_NAME,
    payload
})